export function Footer() {
  return (
    <footer className="app-footer">
      <span>EKORE · AUTOMATION CONTROL TRACKING v1.5.2 · OWW TRADATE</span>
      <span>POLLING 30s · SHELLY CLOUD</span>
    </footer>
  )
}
